import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "propertyTypes";

export const usePropertyTypeStore = defineStore(storeName, () => {
  const all = ref([]);
  const searchQuery = ref(null);
  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);
  const { sortedResources } = useFiltering(all, searchQuery, "attributes.name");
1;
  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("property-types", errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    all,
    fetchAll,
    sortedPropertyTypes: sortedResources
  };
});
